
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stories/happier-healthier",
      function () {
        return require("private-next-pages/stories/happier-healthier.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/stories/happier-healthier"])
      });
    }
  